

import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GETALLUSERS, createCheckIn } from "app/redux/actions";
import {
  Button,
  Grid,
  Box,
  TextField,
  Autocomplete,
  FormControl,
} from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  LocalizationProvider,
  TimePicker,
  DatePicker,
} from "@mui/x-date-pickers";
import { Formik } from "formik";
import * as Yup from "yup";
import { PATH } from "../../../config";
import { useAuth } from 'app/hooks/useAuth';

import dayjs from "dayjs";
const CreateCheck = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useAuth();

  const loggedInUser = useSelector((state) => state.user.user);
  const userList = useSelector((state) => state.user.allUsers?.users || []);

  const isAdminOrLead = useMemo(
    () =>
      loggedInUser?.userType === "admin" ||
      loggedInUser?.userType === "teamlead",
    [loggedInUser]
  );

  useEffect(() => {
    if (loggedInUser?.token && isAdminOrLead) {
      dispatch(
        GETALLUSERS(
          {
            page: 1,
            limit: 1000,
            teamLeadId:
              loggedInUser.userType === "teamlead" ? loggedInUser?.id : null,
          },
          loggedInUser
        )
      );
    }
  }, [dispatch, loggedInUser, isAdminOrLead]);

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      userId:
        loggedInUser?.userType === "admin"
          ? Yup.string().required("Employee selection is required.")
          : Yup.string().nullable(),

      checkIn: Yup.date().required("Check-in time is required.").nullable(),
      checkIn: Yup.date()
        .required("Check-in time is required.")
        .nullable(),
      date: Yup.date().nullable(),
      checkOut: Yup.date().nullable(),
      breakTime: Yup.date().nullable(),
      notes: Yup.string().nullable(),
    });
  }, [loggedInUser]);

  // const handleSubmit = (values) => {
  //   const effectiveDate = values.date || new Date();

  //   const combinedCheckIn = new Date(effectiveDate);
  //   combinedCheckIn.setHours(
  //     new Date(values.checkIn).getHours(),
  //     new Date(values.checkIn).getMinutes()
  //   );

  //   const dateForPayload = new Date(effectiveDate);
  //   dateForPayload.setMinutes(
  //     dateForPayload.getMinutes() - dateForPayload.getTimezoneOffset()
  //   );


  //   let breakTimeInSeconds = 0;
  //   if (values.breakTime) {
  //     const breakDate = new Date(values.breakTime);
  //     const hours = breakDate.getHours();
  //     const minutes = breakDate.getMinutes();
  //     breakTimeInSeconds = (hours * 3600) + (minutes * 60);
  //   }
  //   // const payload = {
  //   //   userId: values.userId || loggedInUser.id,
  //   //   date: dateForPayload.toISOString().split("T")[0],
  //   //   checkIn: combinedCheckIn.toISOString(),
  //   //   notes: values.notes,
  //   //   breakTime: values.breakTime || 0,
  //   // };
  //   const payload = {
  //     userId: values.userId || loggedInUser.id,
  //     date: dateForPayload.toISOString().split("T")[0],
  //     checkIn: combinedCheckIn.toISOString(),
  //     notes: values.notes,
  //     breakTime: breakTimeInSeconds,
  //   };
  //   if (values.checkOut) {
  //     const combinedCheckOut = new Date(effectiveDate);
  //     combinedCheckOut.setHours(
  //       new Date(values.checkOut).getHours(),
  //       new Date(values.checkOut).getMinutes()
  //     );
  //     payload.checkOut = combinedCheckOut.toISOString();
  //   }

  //   dispatch(createCheckIn(payload));
const handleSubmit = (values) => {
 
    const effectiveDate = values.date || new Date();


    const combinedCheckIn = new Date(effectiveDate);
    combinedCheckIn.setHours(
      new Date(values.checkIn).getHours(),
      new Date(values.checkIn).getMinutes(),
      0, 
      0 
    );

 
    let breakTimeInSeconds = 0;
    if (values.breakTime) {
      const breakDate = new Date(values.breakTime);
      const hours = breakDate.getHours();
      const minutes = breakDate.getMinutes();
      breakTimeInSeconds = (hours * 3600) + (minutes * 60);
    }

    const payload = {
      userId: values.userId || loggedInUser.id,
    
      date: dayjs(effectiveDate).format('YYYY-MM-DD'),

      checkIn: combinedCheckIn.toISOString(),
      notes: values.notes,
      breakTime: breakTimeInSeconds,
    };

    if (values.checkOut) {
      const combinedCheckOut = new Date(effectiveDate);
      combinedCheckOut.setHours(
        new Date(values.checkOut).getHours(),
        new Date(values.checkOut).getMinutes(),
        0,
        0
      );

      if (combinedCheckOut < combinedCheckIn) {
        combinedCheckOut.setDate(combinedCheckOut.getDate() + 1);
      }
      payload.checkOut = combinedCheckOut.toISOString();
    }

    dispatch(createCheckIn(payload));

    if (auth.userType === 'admin') {
      navigate(PATH.AllCHECK);
    } else if (auth.userType === 'teamlead' && !values.userId) { 
      navigate(PATH.MYCHECKS);
    } else if (auth.userType === 'teamlead' && values.userId) { 
      navigate(PATH.TEAMCHECKS);
    } else if (auth.userType === 'employee') { 
      navigate(PATH.MYCHECKS); 
    }
  };

  const employeeFieldLabel =
    loggedInUser?.userType === "admin"
      ? "Select Employee *"
      : "Select Team Member";

  return (
    <SimpleCard>
      <Box>
        <Breadcrumb routeSegments={[{ name: "Create Manual Check-in" }]} />
      </Box>
      <Box padding={2}>
        <Formik
          initialValues={{
            userId: "",
            date: new Date(),
            checkIn: null,
            checkOut: null,
            breakTime: null,
            notes: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldValue,
            submitCount,
            setFieldTouched,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                {isAdminOrLead && (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <Autocomplete
                        options={userList}
                        getOptionLabel={(option) => option.name || ""}
                        onChange={(event, newValue) => {
                          setFieldValue("userId", newValue ? newValue.id : "");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={employeeFieldLabel}
                            error={
                              (touched.userId || submitCount > 0) &&
                              Boolean(errors.userId)
                            }
                            helperText={
                              (touched.userId || submitCount > 0) &&
                              errors.userId
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
                {auth.userType === 'admin' ?
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Date *"
                          value={values.date}
                          onChange={(date) => setFieldValue("date", date)}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                  : <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="Date *"
                          disabled
                          value={values.date}
                          onChange={(date) => setFieldValue("date", date)}
                          renderInput={(params) => (
                            <TextField {...params} fullWidth />
                          )}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>
                }
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        label="Check In Time *"
                        value={values.checkIn}
                        onChange={(time) => setFieldValue("checkIn", time)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            onBlur: () => setFieldTouched("checkIn", true),
                            error:
                              (touched.checkIn || submitCount > 0) &&
                              Boolean(errors.checkIn),
                            helperText:
                              (touched.checkIn || submitCount > 0) &&
                              errors.checkIn,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        label="Check Out Time"
                        value={values.checkOut}
                        onChange={(time) => setFieldValue("checkOut", time)}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} md={6}>
                  <TextField
                    label="Break Time"
                    name="breakTime"
                    type="number"
                    fullWidth
                    value={values.breakTime}
                    onChange={handleChange}
                  />
                </Grid> */}
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <TimePicker
                        label="Break Time"
                        ampm={false}
                        views={['hours', 'minutes']}
                        value={values.breakTime}
                        onChange={(time) => setFieldValue("breakTime", time)}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    label="Notes"
                    name="notes"
                    multiline
                    rows={4}
                    fullWidth
                    value={values.notes}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button variant="contained" type="submit">
                    Create Check-in
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </SimpleCard>
  );
};

export default CreateCheck;
